<template>
  <span class="btn-info code-btn" :disabled="disabled" :class="{disabled:disabled}">{{ text }}</span>
</template>

<script>
  export default {
    name: 'verifybutton',
    props: {
      second: {
        type: Number,
        default: 60
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data: function () {
      return {
        time: 0
      }
    },
    methods: {
      run: function () {
        this.time = this.second;
        this.timer()
      },
      timer: function () {
        if (this.time > 0) {
          this.time--;
          setTimeout(this.timer, 1000);
        } else {
          this.$emit('update:disabled', false)
        }
      }
    },
    computed: {
      text: function () {
        return this.time > 0 ? '重新获取' + this.time + 's' : '获取验证码';
      }
    }
  }

</script>
<style lang="scss" type="text/scss" scoped>
  @import "../style/public";

  .btn-info {
    cursor: pointer;
    text-align: center;
    display: inline-block;
    height: 34px;
    line-height: 34px;
    /*background: rgba(0, 151, 254, 0);*/
    /*border: 1px solid rgba(202, 207, 213, 1);*/
    background-color: $themeColor;
    border-radius: 2px;
    box-sizing: border-box;
    color: #fff;
    font-weight: bold;

    &:hover {
      /*background: rgba(85, 190, 208, 1);*/
      /*border: 0;*/
      background-color: $themeBlueColor;
      /*color: white;*/
    }

    &.disabled {
      cursor: not-allowed;
      background: darkgray;
      color: white;
      font-weight: normal;

      &:hover {
        background: darkgray;
        color: white;
        border: 1px solid rgba(202, 207, 213, 1);
      }
    }
  }

  .code-btn {

    padding: 0 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/VerifyButton.vue